import React from 'react';
import { Col, Divider, Row } from 'antd';

import {
  MemberHistoryDetailsModel,
  ProfileCorporateSupervisorInfoModel,
} from 'api/adminApiClient';
import HistoryLog from '../../HistoryLog';
import HistoryField from '../../HistoryField';

import styles from '../../HistoryCard.module.less';

type Props = {
  historyDetails: MemberHistoryDetailsModel;
  historyId: string;
};

export default function SupervisorInformationDetailsCard(props: Props) {
  const { historyDetails, historyId } = props;
  const { oldData, newData } = historyDetails;

  const renderSupervisors = (
    supervisors?: ProfileCorporateSupervisorInfoModel[],
  ) => {
    const sectionName = 'supervisor';

    return (
      <>
        <Row gutter={[10, 10]}>
          <Col xs={24}>
            <div className={styles.cardTitle}>Supervisor</div>
          </Col>

          <Col xs={24}>
            {supervisors?.length ? (
              supervisors.map((supervisor, index) => (
                <React.Fragment key={`${supervisor.supervisorId}-${index}`}>
                  <Row gutter={[10, 10]}>
                    <HistoryField
                      title="First name"
                      value={supervisor?.firstName}
                      dataId={`${sectionName}-first-name-field`}
                    />
                    <HistoryField
                      title="Last name"
                      value={supervisor?.lastName}
                      dataId={`${sectionName}-last-name-field`}
                    />
                    <HistoryField title="Email" value={supervisor?.email} />
                    <HistoryField
                      title="Phone number"
                      value={supervisor?.phoneNumber}
                      dataId={`${sectionName}-phone-number-field`}
                    />
                    <HistoryField
                      title="Title"
                      value={supervisor?.title}
                      dataId={`${sectionName}-title-field`}
                    />
                  </Row>

                  <Divider />
                </React.Fragment>
              ))
            ) : (
              <div className={styles.noDataMessage}>No data</div>
            )}
          </Col>
        </Row>

        <Divider />
      </>
    );
  };

  return (
    <HistoryLog
      historyId={historyId}
      oldData={renderSupervisors(oldData?.corporateInfo?.supervisors)}
      newData={renderSupervisors(newData?.corporateInfo?.supervisors)}
    />
  );
}
